var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-muted text-center",domProps:{"textContent":_vm._s(_vm.calculateOrdinalNumber(_vm.index, _vm.perPage, _vm.currentPage))}})}
var staticRenderFns = []

export { render, staticRenderFns }